<script lang="ts">
  let {
    url,
    pageCount = 0,
    stale = false,
    pending = false,
  }: { url: string | null; pageCount?: number; stale?: boolean; pending?: boolean } = $props()
</script>

<section aria-label="PDF-Vorschau">
  <p aria-live="polite">
    {pending
      ? "PDF-Vorschau wird geladen …"
      : stale
        ? "Vorschau nicht aktuell"
        : url
          ? `Musterbrief · ${pageCount} ${pageCount === 1 ? "Seite" : "Seiten"}`
          : "Vorschau noch nicht erstellt."}
  </p>
  {#if url}
    {#key url}
      <object data={url} type="application/pdf" aria-label="Musterbrief als PDF">
        <p
          >Die PDF-Vorschau wird von diesem Browser nicht unterstützt. Bitte öffnen Sie die
          PDF-Datei.</p
        >
      </object>
    {/key}
    <a href={url} target="_blank" rel="noopener noreferrer">PDF öffnen</a>
    <a href={url} download="briefvorschau.pdf">Vorschau herunterladen</a>
  {:else}
    <div class="preview-placeholder" aria-busy={pending}>
      {pending
        ? "Ihr Musterbrief wird erstellt …"
        : "Die Vorschau ist noch nicht verfügbar. Bitte erneut laden."}
    </div>
  {/if}
  <p class="note"
    >Beispieldaten, kein Versand. Echte Briefe können bei längeren Angaben weitere Seiten enthalten.</p
  >
</section>

<style>
  section {
    min-width: 0;
    color: var(--text-invers-100);
  }
  object {
    display: block;
    width: 100%;
    height: min(70vh, 900px);
    min-height: 380px;
    border: 1px solid color-mix(in srgb, var(--text-invers-100) 25%, transparent);
  }
  a {
    display: inline-block;
    margin: 0.65rem 0.8rem 0.2rem 0;
    color: var(--text-invers-100);
  }
  .note {
    font-size: 0.85rem;
    color: var(--text-invers-100);
    line-height: 1.5;
  }
  .preview-placeholder {
    display: grid;
    place-items: center;
    min-height: 22rem;
    padding: 1.5rem;
    border: 1px solid color-mix(in srgb, var(--text-invers-100) 20%, transparent);
    background: color-mix(in srgb, var(--text-invers-100) 4%, transparent);
    color: var(--text-invers-100);
    text-align: center;
  }
</style>
